import axios from "axios";

/**
 * API base URL.
 *
 * Defaults to a same-origin relative "/api" so the built bundle carries no
 * hard-coded hostname and works under whatever domain serves it — zaplee.ai,
 * a staging subdomain, or a preview URL — with the PHP backend dropped in at
 * <docroot>/api. Set REACT_APP_API_BASE_URL only when the API genuinely lives
 * on a different origin (it is baked in at build time).
 */
const configured =
  process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BACKEND_URL || "";

export const API_BASE = configured
  ? `${configured.replace(/\/+$/, "")}/api`
  : "/api";

export const api = axios.create({ baseURL: API_BASE });

const TOKEN_KEY = "zaplee.admin.token";

export const getToken = () => {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch {
    // Private-mode Safari and hardened browsers can throw on localStorage.
    return null;
  }
};

export const setToken = (token) => {
  try {
    window.localStorage.setItem(TOKEN_KEY, token);
  } catch {
    /* non-fatal: the session just will not survive a reload */
  }
};

export const clearToken = () => {
  try {
    window.localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* no-op */
  }
};

/** Attach the admin bearer token to every outgoing request when present. */
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
  }
  return config;
});

/** Pull a human-readable message out of an axios error. */
export const errorMessage = (err, fallback = "Something went wrong. Please try again.") => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  if (err?.response?.status === 401) return "Your session expired. Please sign in again.";
  return fallback;
};
